/*
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2020 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { searchHistoryStyles } from "@eisinc/Overrides/Widgets/Header/SearchHistory";
import color from "@eisinc/XDL/Utilities/color";
import { css } from "styled-components";

searchHistoryStyles.wrapper = {
    css: css``,
};

searchHistoryStyles.headerText = {
    weight: "bold",
    size: "16px",
    lineHeight: "18px",
    css: css`
        display: block;
        text-transform: uppercase;
        letter-spacing: 0.3px;
        text-align: left;
        margin: 30px -40px 5px -40px;
        padding: 10px 40px;
        background-color: ${color("common.ui5", 0.35)};

        &:first-child {
            margin-top: 0;
        }
    `,
};

searchHistoryStyles.link = {
    ...searchHistoryStyles.link,
    color: "text.main",
};
